import { render, staticRenderFns } from "./ConfirmEmail.vue?vue&type=template&id=3275b46d&scoped=true&"
import script from "./ConfirmEmail.vue?vue&type=script&lang=js&"
export * from "./ConfirmEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3275b46d",
  null
  
)

export default component.exports